import React from 'react';
import { Link } from 'react-router-dom';

import parseServerChangeLog from './ActionTypes/parseServerLog';

const ItemMessage = ({ details, type }) => {
  const displayItemMessage = () => {
    const {
      subject,
      to,
      taskId,
      description,
      taskType,
      campaignName,
      sourceClaimId,
      destinationClaimId,
      passengerTicketId,
      passengerFullName = ''
    } = parseServerChangeLog(details);
    let ticketIds = [],
      pluralTicketIds = 0;

    if (type === 'TaskClosed' || type === 'TaskRejected') {
      ticketIds = Object.keys(parseServerChangeLog(details));
      pluralTicketIds = ticketIds.length > 1;
    }

    switch (type) {
      case 'EmailSent':
        return (
          <p>
            Email with subject: <b>{subject}</b> has been sent to: <b>{to}</b>{' '}
          </p>
        );
      case 'EmailReceived':
        return (
          <p>
            Email with subject: <b>{subject}</b> has been recieved from:{' '}
            <b>{to}</b>
          </p>
        );
      case 'AirlineEmailEventOccurred':
        return (
          <p>{subject}</p>
        );
      case 'TaskCreated':
        return (
          <p>
            Task with id:{' '}
            <b>{<Link to={`/task/${taskId}`}>{taskId}</Link>}</b> has been
            created, description: <b>{description}</b>, type: <b>{taskType}</b>
          </p>
        );
      case 'TaskCompleted':
        return (
          <p>
            Task with id: <b>{taskId}</b> has been completed <b>{subject}</b>
          </p>
        );
      case 'TaskClosed':
        return (
          <p>
            {`${ticketIds.length} Task${pluralTicketIds ? 's have' : ' has'}`}{' '}
            been closed
          </p>
        );
      case 'TaskRejected':
        return (
          <p>
            {`${ticketIds.length} Task${pluralTicketIds ? 's have' : ' has'}`}{' '}
            been rejected
          </p>
        );
      case 'ParametrizedEmailSent':
        return (
          <p>
            Campaign: <b>{campaignName}</b>
          </p>
        );
      case 'PassengerMovedIn':
        return (
          <p>
            Passenger{' '}
            <b>
              <Link to={`/ticket/${passengerTicketId}`}>
                #{passengerTicketId}
              </Link>
            </b>{' '}
            ({passengerFullName}) has been moved from claim{' '}
            <b>
              <Link to={`/claim/${sourceClaimId}`}>#{sourceClaimId}</Link>
            </b>
          </p>
        );
      case 'PassengerMovedOut':
        return (
          <p>
            Passenger{' '}
            <b>
              <Link to={`/ticket/${passengerTicketId}`}>
                #{passengerTicketId}
              </Link>
            </b>{' '}
            ({passengerFullName}) has been moved to claim{' '}
            <b>
              <Link to={`/claim/${destinationClaimId}`}>
                #{destinationClaimId}
              </Link>
            </b>
          </p>
        );
      default:
        return '';
    }
  };
  return displayItemMessage();
};

export default ItemMessage;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimHistory/HistoryItem/ItemMessage.js